<template src="./OtaChange.html"></template>
<script lang="js">
import Vue from 'vue';
import {navigateTo, resolve} from '@seamless/router';
import axios from "axios";
import {AnalyzeIdentifier} from "../../plugins/analyzeIdentifier";

export default Vue.extend({
  name: 'nmouc-ota-change',
  computed: {
    showOtaRegion() {
      if (this.isRegionSelected) {
        return true;
      }
      return this.$store.getters.getSelectedOtaRegion !== undefined;
    },
    otaRegionDescription() {
      if (this.isRegionSelected) {
        return this.$store.state.otaChange.selectedRegion.regionDescription;
      }
      if (this.$store.getters.getSelectedOtaRegion !== undefined) {
        return this.$store.getters.getSelectedOtaRegion.regionDescription;
      }
      return "-";
    },
    isRegionSelected() {
      return this.$store.state.otaChange.selectedRegion !== undefined;
    },
    showClickOnMapHint() {
      return !this.isRegionSelected
    },
    showChangeButton() {
      return this.isRegionSelected
        && this.$store.state.otaChange.selectedRegion.otaUpdatePossible
    },
    showOtaChangeNotPossible() {
      return this.isRegionSelected
        && !this.$store.state.otaChange.selectedRegion.otaUpdatePossible;
    },
    analyzeIdentifier() {
      return AnalyzeIdentifier.ID;
    }
  },
  data() {
    return {
      otaChangeDisabled: false,
      otaChangeError: false,
    }
  },
  watch: {
    '$store.state.otaChange.selectedRegion': function () {
      this.otaChangeError = false;
    }
  },
  methods: {
    close() {
      this.otaChangeError = false;
      this.$store.commit('setOtaChangeSelectedRegion', undefined)
    },
    changeOta() {
      if (process.env.VUE_APP_TESTDATA === "true") {
        if (process.env.VUE_APP_OTA_CHANGE_ERROR === "true") {
          this.setOtaChangeError()
        } else {
          this.navigateToOverview();
        }
      } else {
        axios.post(`/mapupdate/api/v1/vehicles/${this.$store.state.vin}/otaregion`,
          {
            regId: this.$store.state.otaChange.selectedRegion.regId
          },
          {
            withCredentials: true
          })
          .then(() => {
            this.otaChangeError = false;
            this.navigateToOverview();
          })
          .catch((error) => {
            console.log("error", error);
            this.setOtaChangeError()
          })
      }
    },
    gotoManualUpdate() {
      let mapRegion = this.$store.state.otaChange.selectedRegion;
      this.$store.commit('toggleManualUpdateSelectedRegion', mapRegion)
      this.$store.commit('resetOtaChangeSelectedRegion')
      const newUrl = resolve({namespace: 'mapupdate', path: "/manualupdate"});
      navigateTo(newUrl);
    },
    navigateToOverview() {
      this.$store.commit('setSelectedOtaRegionInMapUpdateInformation',
        this.$store.state.otaChange.selectedRegion.regId);
      const newUrl = resolve({namespace: 'mapupdate', path: "/"});
      navigateTo(newUrl);
    },
    setOtaChangeError() {
      this.otaChangeError = true;
      this.otaChangeDisabled = true;
    },
    setOtaChangeSelectedRegion(region) {
      this.$store.commit('setOtaChangeSelectedRegion', region);
    },
    isThisRegionSelected(region) {
      if (this.$store.state.otaChange.selectedRegion !== undefined) {
        return this.$store.state.otaChange.selectedRegion.regId === region.regId;
      }
      if (this.$store.getters.getSelectedOtaRegion !== undefined) {
        return this.$store.getters.getSelectedOtaRegion.regId === region.regId;
      }
      return false;
    }
  }
});
</script>
<style lang="scss" scoped>
.warning-icon {
  width: 18px;
  height: 18px;
  margin-right: 0px;
  margin-bottom: 0px;
  padding-bottom: 3px;
}
</style>
